import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationDataApi, DataForPatchingFlow } from 'api/ApplicationDataApi';
import { CurrentFlow } from 'enums/CurrentFlow';

import { ErrorResponse } from './ErrorResponse';

export const createUpdateCurrentFlowThunk = (api: ApplicationDataApi) =>
  createAsyncThunk<CurrentFlow, DataForPatchingFlow>('/application/currentFlow', async (data, thunkApi) => {
    try {
      await api.updateApplicationStatus({
        applicationId: data.applicationId,
        applicationFlow: data.currentFlow,
      });

      return data.currentFlow;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
